import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { DeleteOutlined } from '@ant-design/icons';
import { theme, message, Popconfirm } from 'antd';
import { RootState } from 'store/configureStore';
import { complianceEstOp } from 'store/ducks/ComplienceEst';
import { IEvidencesToShow } from 'store/ducks/Evidences/types';
import CustomTextarea from '../CustomTextarea';
import CommentSection from '../CommentSection';
import * as Styled from './TextAreaBoxEvidences.styled';
import Helpers from 'utils/Helpers';

interface ITextAreaBoxProps {
  evidences: IEvidencesToShow;
  evidenceId?: number;
  onDelete?: (id: string | number) => void;
  onChange?: (value: string) => void;
  value?: string;
}

interface IPopoverState {
  [id: number | string]: boolean;
}

const { useToken } = theme;

const cancel = () => {
  message.error('Evidence was not deleted');
};

export const TextAreaBoxEvidences: React.FC<ITextAreaBoxProps> = ({
  evidences,
  evidenceId,
  onDelete,
  onChange,
  value
}) => {
  const { token } = useToken();
  const dispatch = useDispatch();

  const { commentsData, lang, orgContext } = useSelector(
    (state: RootState) => ({
      commentsData: state.complianceEst.commentsData,
      lang: state.global.lang,
      orgContext: state.global.hierarchicalLevelsScope
    })
  );
  const filterParams = Helpers.toApiFilters(orgContext);
  const evidenceData =
    (evidences as any)?.SOLUTIONS?.EVIDENCES ??
    (evidences as any)?.solution?.EVIDENCES ??
    evidences;

  const evd_id = evidenceData?.evd_id;
  const evd_desc = evidenceData?.evd_desc ?? '';
  const [popoverState, setPopoverState] = useState<IPopoverState>({});
  const handleDeleteClick = async () => {
    if (onDelete) {
      onDelete(evd_id ?? (evidences as any).key);
    }
  };

  // const drawComments = () => {
  //   const filteredComments = commentsData?.length
  //     ? commentsData.filter(
  //         (commentsDataItem: CommentItem) =>
  //           commentsDataItem.res_table_pk_ref === evidenceId
  //       )
  //     : [];

  //   return (
  //     <>
  //       {evidenceId && (
  //         <>
  //           <CommentSection
  //             reqId={evidenceId}
  //             data={filteredComments}
  //             tableRef={CommentTable.EVIDENCES}
  //           />
  //           <a onClick={() => hide(evidenceId)}>Close</a>
  //         </>
  //       )}
  //     </>
  //   );
  // };

  return (
    <Styled.TextAreaElementsContainer>
      <Styled.TextAreaElementsContainer>
        <CustomTextarea
          placeholder='Evidence Definition'
          defaultValue={evd_desc}
          value={value || ''}
          onChange={(e) => {
            const newValue = e.target.value;
            onChange?.(newValue);
            dispatch(complianceEstOp.setSaveDisabled(false));
          }}
        />
        <Styled.StyledButtonSection token={token}>
          {/* Comment section hidden
          {evidenceId && (
            <Popover
              placement='leftBottom'
              trigger='click'
              content={drawComments}
              title='Comments'
              open={!!(evidenceId && popoverState[evidenceId])}
              onOpenChange={() => handleOpenChange(evidenceId)}
            >
              <CustomIconButton
                type='primary'
                shape='circle'
                icon={<CommentOutlined />}
                size='small'
                cursor='pointer'
              />
            </Popover>
          )}
          */}

          <Popconfirm
            title='Delete the evidence'
            description='Are you sure to delete this evidence?'
            onConfirm={handleDeleteClick}
            onCancel={cancel}
            okText='Yes'
            cancelText='No'
          >
            <Styled.StyledCustomIconButton
              token={token}
              type='primary'
              shape='circle'
              icon={<DeleteOutlined />}
              cursor='pointer'
              size='small'
            />
          </Popconfirm>
        </Styled.StyledButtonSection>
      </Styled.TextAreaElementsContainer>
    </Styled.TextAreaElementsContainer>
  );
};
